// All static content for DrugAwarenessUSA.net cloned from DrugAwarenessUSA.com

export const SITE = {
  name: 'DrugAwarenessUSA.net',
  brand: 'Kress & Associates',
  tagline: 'Drug & Alcohol Awareness',
  phone: '(814) 460-8447',
  address: {
    line1: 'Kress & Associates',
    line2: '11600 West Greene Rd',
    line3: 'Waterford, PA 16441',
    country: 'United States',
  },
  facebook: 'https://www.facebook.com/pages/Kress-Associates/610340492350617',
};

export const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Overview', to: '/overview' },
  { label: 'Program', to: '/program' },
  { label: 'Evaluation', to: '/evaluation' },
  { label: 'Endorsements', to: '/endorsements' },
  { label: 'Awards', to: '/awards' },
  { label: 'Bio', to: '/bio' },
  { label: 'Media', to: '/media' },
  { label: 'Single Handed', to: '/single-handed' },
  { label: 'Buy the Ebook', to: '/single-handed/buy' },
  { label: 'Socials', to: '/socials' },
  { label: 'Recent Activities', to: '/recent-activities' },
  { label: 'Donate', to: '/donate' },
  { label: 'Contact', to: '/contact' },
];

export const HERO_IMAGES = [
  'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1920&q=80',
  'https://images.unsplash.com/photo-1570616969692-54d6ba3d0397?auto=format&fit=crop&w=1920&q=80',
  'https://images.unsplash.com/photo-1562884328-39da45501a9c?auto=format&fit=crop&w=1920&q=80',
];

export const CARDS = [
  {
    id: 'evaluation',
    title: 'EVALUATION',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80',
    to: '/evaluation',
    blurb:
      'An independent assessment by the Mercyhurst College Civic Institute of Erie, PA. Read the study findings.',
  },
  {
    id: 'program',
    title: 'PROGRAM',
    image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?auto=format&fit=crop&w=800&q=80',
    to: '/program',
    blurb:
      '"Drug and Alcohol Awareness: The Value of Making the Right Choices" — grades 6-12.',
  },
  {
    id: 'endorsements',
    title: 'ENDORSEMENTS',
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=800&q=80',
    to: '/endorsements',
    blurb:
      'Letters and accolades from principals, teachers, resource officers, and students.',
  },
  {
    id: 'overview',
    title: 'OVERVIEW',
    image: 'https://images.pexels.com/photos/37758744/pexels-photo-37758744.jpeg?auto=compress&cs=tinysrgb&w=800',
    to: '/overview',
    blurb:
      'Kress & Associates provides drug and alcohol education to schools throughout Western PA.',
  },
  {
    id: 'awards',
    title: 'AWARDS',
    image: 'https://images.unsplash.com/photo-1613264520739-c2eb038e8404?auto=format&fit=crop&w=800&q=80',
    to: '/awards',
    blurb:
      'Proclamation for Heroism, Medal of Valor, Purple Heart, Commendation Awards and more.',
  },
  {
    id: 'bio',
    title: 'BIO',
    image: 'https://images.unsplash.com/photo-1709507531336-3e681fd91956?auto=format&fit=crop&w=800&q=80',
    to: '/bio',
    blurb:
      'Lt. Joseph M. Kress — 25+ years of law enforcement and drug enforcement expertise.',
  },
];

export const EVALUATION = {
  intro:
    'An independent assessment of the Drug and Alcohol Awareness: The Value of Making the Right Choice Program was conducted by the Mercyhurst College Civic Institute of Erie, Pennsylvania.',
  paragraphs: [
    'The Civic Institute prepared a 78-question pre and post evaluation for the purpose of finding out the students’ attitudes and opinions about drug and alcohol use before and after the program was presented.',
    'The pre-evaluation was administered to students participating in the program. Students then attended the presentation of the program. After a significant period of time, the post-evaluation was then given to the students. The pre and post evaluations were then collected and tabulated by the Mercyhurst College Civic Institute.',
    'The comparison of the pre and post evaluations showed a significant difference, in literally every aspect.',
    'This evaluation strongly indicated a dramatic change in the attitudes and opinions, in a very positive way, of all the students that participated.',
  ],
  stats: [
    { label: 'Question Pre/Post Evaluation', value: '78' },
    { label: 'Program Effectiveness Rating', value: '100%' },
    { label: 'Grades Reached', value: '6-12' },
  ],
};

export const PROGRAM = {
  headline: 'Drug and Alcohol Awareness: The Value of Making the Right Choices',
  paragraphs: [
    'With twenty-five years of law enforcement expertise and ten years of experience in the social services arena, Kress & Associates recognizes society’s difficulty with drug and alcohol addiction recovery programming. Addict recovery programming is reactionary, not proactive. Statistics from the Department of Justice show that eight out of ten crimes committed are drug and alcohol related, and 51% of high school seniors reported using illegal drugs. We are unsuccessful in preventing substance usage among our youth.',
    'When 100 million Americans age 12 and older report having used illicit drugs, we must make a change. This proposal contains statistical data from the U.S. Department of Justice Bureau of Justice Statistics, the Pennsylvania Department of Corrections, and the Department of Education. The data clearly demonstrates the enormous task before us to proactively modify the conduct of our youth.',
    'Kress & Associates has been providing an educational program to schools in the Western Pennsylvania area. "Drug and Alcohol Awareness: The Value of Making the Right Choices" has been educating all levels of secondary school students as to the damage drugs and alcohol can have on a person’s life and one’s family. This program has been presented to sixth through 12th grades. The impact the program has on students is vividly expressed in drug use admissions of students at the presentations and afterward, then amplified by endorsement letters and accolades from School Principals, Assistant Principals, School Counselors, School Nurses, Teachers, School Resource Officers and most importantly the students themselves.',
    'Erie Police Lieutenant Joseph M. Kress is a decorated police officer earning numerous Awards and Commendations. He worked in and supervised the Erie Police Narcotics Unit for over ten years. Lt. Kress has been qualified eighty-five times as an expert in the field of drugs in Pennsylvania Commonwealth Court. He presents true-life experiences that begin with the murder of his brother by a drug addict during a robbery attempt.',
    'During each presentation, when the question is asked, "How many students know someone who either uses or sells drugs in this school?", every hand is raised. Lt. Kress also shares how, during a drug raid, he was shot by a drug dealer and narrowly escaped death for what he believes in.',
    'Alongside Lt. Kress, a young prison inmate shares how drugs and alcohol started him on a road of destruction at the age of fifteen. Alcohol was the vehicle that helped an A student become a high school dropout, a seventeen-year-old father, an alcoholic, a marijuana addict, cocaine user, and a gun-toting drug dealer by the age of seventeen. At the age of eighteen, he was arrested for a felony assault, prosecuted, and incarcerated.',
    'Finally, a career criminal shares his experiences and the lifestyle that led him to spending years behind bars. Prior to making changes in his life, the former convict makes it clear how drugs and alcohol played a part in his criminal career.',
    'At the conclusion of the presentation, numerous students have tearful eyes. This thought-provoking presentation invites students to ask questions of the presenters. Every school Administrator has been impressed how this presentation is the talk of the school for days afterward.',
    'Each school will be provided the opportunity to have a reminder sign stating "Make the Right Choice Today" installed on school property in a strategic location after the presentation.',
    'Kress & Associates can present the program to one thousand eighty-nine (1,089) secondary students for the cost of incarcerating one (1) prisoner for a period of one year. For the same cost of incarcerating ninety-one (91) individuals for a period of one year, this program can be presented to 100,000 secondary students. It is time to be proactive in our priorities.',
  ],
};

export const OVERVIEW = {
  paragraphs: [
    'Kress & Associates has been providing an educational program to schools in the Western Pennsylvania area. "Drug and Alcohol Awareness: The Value of Making the Right Choices" has been educating all levels of secondary school students as to the damage drugs and alcohol can have on a person’s life and one’s family.',
    'This program has been presented to sixth through 12th grades. The impact the program has on students is vividly expressed in drug use admissions of students at the presentations and afterward, then amplified by endorsement letters and accolades from School Principals, Assistant Principals, School Counselors, School Nurses, Teachers, School Resource Officers and, most importantly, the students themselves.',
    'The demand from the school districts for this presentation is overwhelming.',
  ],
};

export const ENDORSEMENTS = [
  {
    name: 'Gregg McClelland',
    role: 'Principal, Girard High School',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=200&q=80',
    body: [
      'Dear Lieutenant Kress, I wanted to take the time to write you today and express my thanks to both you and Paul for speaking at Girard High School. I cannot tell you how impressed I was with both of your speeches that day. The feedback I have personally gathered from the faculty and students alike has been overwhelmingly positive.',
      'The session I sat in on with approximately 120 students and staff was almost spellbinding. I could have heard a pin drop during the entire 90-minute presentation. As I looked around, I watched our students’ reactions, and they were hanging on every word. They were attentive, shocked, appalled and saddened by the things they were hearing about the effects that alcohol and drugs have on a person’s life.',
      'I have already raved about your program to the superintendent and principals from other schools. You are providing an invaluable service to school districts, communities and young people in general. Keep up the fantastic work.',
    ],
  },
  {
    name: 'Catherine',
    role: 'Student, 9th grade',
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=200&q=80',
    body: [
      'Hello, my name is Catherine. About two and a half years ago my mother died in a car accident. I was also in the car and suffered in a coma for about a month. Previous to the accident, I had never experimented with drugs.',
      'I have been off drugs for a while now, I have made new, good friends, my grades are going back up, and I finally have control of my life. I am really glad that Mrs. Preston invited me personally to your presentation. After hearing your presentation, I found that I am lucky that I stopped before something really bad happened.',
      'I have control of my life, and you helped. Thanks.',
    ],
  },
  {
    name: 'Deputy Jon M. Habursky',
    role: 'Erie County Sheriff’s Office — Harbor Creek School Resource Officer',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=200&q=80',
    body: [
      'Dear Lt. Kress, I cannot thank you enough for bringing the presentation to Harbor Creek Junior and Senior High Schools. The administration, staff and students are still talking about the presentation.',
      'Since the initial day when you first presented, I have had a number of students speak to me about their present addictions, requesting help. Additionally, students have stepped forward to assist a friend or classmate that has an alcohol and/or drug problem. We now have a total of ten students receiving drug treatment services, due to your program.',
      'The impact of the program cannot be truly measured in dollars or cents. The impact on saving lives and getting students in need help is immeasurable. Together we can make a difference!',
    ],
  },
  {
    name: 'Daniel L. Daum',
    role: 'Principal, Corry Area High School',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
    body: [
      'Dear Lieutenant Kress, I once again would like to thank you for the FBI Adopt A School presentation you gave. Four days after, students are still talking about it. I would go on record saying that your presentation is one of the strongest and most lasting speeches our students will see in their high school career.',
      'The straight-forwardness with which you speak is appreciated by the students and certainly heard. Thank you, and I hope you are available to speak to future classes.',
    ],
  },
  {
    name: 'Linda D. Allen',
    role: 'Principal, Harbor Creek School District',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=200&q=80',
    body: [
      'Dear Lt. Kress, I cannot thank you enough for bringing all of the members of your team to our school. Together you deliver a powerful message! The effects are still being felt, as students keep asking to talk to someone about their problem addictions.',
      'All too often, students hear about what "can happen" to someone who gets mixed up in drugs. Your program showed them what "does happen." If a picture is worth a thousand words, having someone who is close to the students’ age, and is living the consequences of being involved in drugs, is immeasurable.',
    ],
  },
  {
    name: 'Teressa Wilczynski',
    role: 'Student, Harborcreek High 7th grade',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80',
    body: [
      'Wow is all I have to say about the assembly! It was so touching to me. There are a lot of kids at Harborcreek who have been into drugs and I’m happy that you guys came because maybe now they’ll change their acts.',
      'Sharing their stories with kids may change the future. Nobody is perfect in this world and we shouldn’t expect anyone to be. I really think that they should do that more often all around.',
    ],
  },
  {
    name: 'Jennifer Ritter, Ph.D.',
    role: 'Assistant Principal, North East School District',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80',
    body: [
      'Dear Lt. Kress, I want to thank you and Paul for speaking to the eighth-grade class. When you asked how many of the students knew someone who used or sold drugs and every hand was raised, I was shell-shocked.',
      'You provided for my students real-life stories. However, bringing a prisoner in leg irons and an orange jump suit made an impact on even the faculty. Joe, we will never be able to measure exactly what your presentation has done in numbers of students who do not use or have stopped using, but I know that your work has changed my understanding of the importance of this work.',
    ],
  },
  {
    name: 'Molly Peterson',
    role: 'Student',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=200&q=80',
    body: [
      'Hi, my name is Molly and all I can say is that your program blew me away, it left me speechless. We have always been told not to use drugs, but I think your program taught us more than any of our other ones.',
      'It had stories of things that actually happened to people who had used them and I thought that it was very unique for you to do that. I think it is great that you go to all these schools to inform us not because you have to, but because you want to. I really admire you.',
    ],
  },
];

export const AWARDS = [
  {
    title: 'Proclamation for Heroism',
    body: 'On March 12, 1997, Officer Kress received the Proclamation for Heroism and Meritorious Service for entering a burning building in the early morning hours to rescue numerous persons who were sleeping in a boarding house. All residents were able to escape safely.',
  },
  {
    title: 'Medal of Valor and Purple Heart',
    body: 'On March 14, 1991, during the service of a drug search warrant, Officer Kress received a gunshot wound through his right thigh. Officer Kress was exposed to hostile gunfire and remained in his position until entry was successfully completed.',
  },
  {
    title: 'Commendation Award & Unit Commendation Award',
    body: 'On October 11, 2002, Lieutenant Kress received a Commendation Award and Unit Commendation Award for his part in a major drug conspiracy operation that led to the federal arrest and conviction of thirty-one persons, seizure of seventeen kilos of cocaine and $15,000 in cash.',
  },
  {
    title: 'Letters of Commendation',
    body: 'Lieutenant Kress has received thirty-one Letters of Commendation during his tenure as an Erie Police Officer.',
  },
  {
    title: 'Expert Witness Qualifications',
    body: 'Lieutenant Kress has been qualified as an Expert Witness in the field of drugs eighty-five times in Commonwealth Court.',
  },
];

export const WORK_HISTORY = [
  {
    period: '1/04 — 11/08',
    dept: 'City of Erie Bureau of Police',
    title: 'Federal Liaison / Lieutenant',
    body:
      'Coordinated joint operations with federal agencies including the FBI, U.S. Secret Service, ICE, DEA, ATF, USDA-OIG, U.S. Postal Inspection Service, IRS, U.S. Marshals Service, U.S. Department of State and U.S. Coast Guard. During the 2004 Presidential Campaign, Lt. Kress supervised campaign visits for President George W. Bush, Vice President Richard Cheney, Senator John Kerry, Senator John Edwards, Mrs. Heinz-Kerry, and Mrs. Edwards.',
  },
  {
    period: '1/02 — 1/04',
    dept: 'City of Erie Bureau of Police',
    title: 'Narcotics and Vice Commander / Lieutenant',
    body:
      'Supervised the Narcotics Unit and Criminal Drug Intelligence Division. Responsible for the direct supervision of eight investigators and one office manager. Oversaw drug law enforcement case management and coordinated drug buys, confidential informants, surveillance, wiretap activity, arrests, prosecutions, and joint operations.',
  },
  {
    period: '5/96 — 1/02',
    dept: 'City of Erie Bureau of Police',
    title: 'Narcotics Investigator / Detective Sergeant / SWAT Team Member',
    body:
      'Supervised Detectives in the Narcotics Unit. Conducted surveillance, controlled hand-to-hand buys, wiretaps and recordings, arrests, search warrants, raids on drug distribution houses, and criminal prosecutions.',
  },
  {
    period: '10/96 — 1/98',
    dept: 'City of Erie Bureau of Police',
    title: 'Narcotics Investigator / Detective Sergeant (EAGLE) / SWAT',
    body:
      'Served as Task Force Supervisor on the Erie Area Gang Law Enforcement Task Force — a multi-jurisdictional federal task force investigating top-level drug dealers. Deputized as an FBI Agent with federal authority.',
  },
  {
    period: '5/86 — 10/94',
    dept: 'City of Erie Bureau of Police',
    title: 'Fourth Platoon Member / Patrol Division',
    body:
      'Special tactical unit responding to all critical incidents, high-risk arrests, and search warrant service. First responders for all high-risk incidents.',
  },
  {
    period: '8/83 — 5/86',
    dept: 'City of Erie Bureau of Police',
    title: 'Patrol Division / Patrol Officer',
    body:
      'Regular patrol unit responding to all calls for service; effected hundreds of arrests for violations of the Pennsylvania Crimes Code and Pennsylvania Motor Vehicle Code.',
  },
];

export const TASK_FORCES = [
  'Pennsylvania Attorney General Task Force',
  'Erie Area Gang Law Enforcement Task Force',
  'Erie County Mobile Drug Task Force',
];

export const TRAINING = [
  { title: 'Basic Municipal Police Training', org: 'Pennsylvania State Police Academy, Meadville, PA', date: 'August to November 1983' },
  { title: 'Precision Rifle Marksmanship Training', org: 'United States Special Forces', date: 'May 24, 1993' },
  { title: 'Advanced Sniper Course Project North Star', org: 'Chautauqua County Sheriff’s Academy', date: 'September 23, 1993' },
  { title: 'Caribbean Organized Drug Crime', org: 'MAGLOCLEN', date: 'October 12, 1994' },
  { title: 'Narcotics in the Mail, Interdiction and Clandestine Labs', org: 'U.S. Department of Justice', date: 'February 23, 1995' },
  { title: 'Crack Cocaine & Street Level Drugs', org: 'Dade County Florida Sheriff’s Office', date: 'November 7, 1995' },
  { title: 'PA Wiretapping and Electronic Surveillance Training', org: 'PA State Police Academy, Hershey, PA', date: 'November 18, 1996' },
  { title: 'Rave Clubs and Club Drugs / Multi-jurisdictional Counterdrug Task Force Training', org: 'Florida National Guard', date: '1998' },
  { title: 'Financial Investigations / Laundering Drug Proceeds', org: 'PA National Guard / Northeast Counterdrug Training Center', date: 'July 11, 2000' },
  { title: 'High Risk Warrant & Hostage Rescue Tactics', org: 'Blackwater Training Center', date: 'November 6, 2000' },
  { title: 'Drug Unit Commanders Academy', org: 'United States Drug Enforcement Administration', date: 'February 2002' },
  { title: 'Dignitary Protection Seminar', org: 'United States Secret Service', date: 'August 2004' },
];
